import { render, staticRenderFns } from "./referential-base.vue?vue&type=template&id=3312bf43&"
import script from "./referential-base.vue?vue&type=script&lang=ts&"
export * from "./referential-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports